import React, { useState, forwardRef, useImperativeHandle } from "react";
import {Button,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        CircularProgress,
        Checkbox,
        FormControlLabel,
        FormHelperText
} from "@material-ui/core";

// localStorage
import { useLocalStorage } from 'usehooks-ts'

import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';

const CustomerDownloadCSVConfirmation = forwardRef((props, ref) => {
    const { closeMenu, onConfirmationSuccess } = props;
    const classes = useStyles();
    const [customerId, setCustomerId] = useState(-1);
    const [customerName, setCustomerName] = useState(-1);
    const [openConfirmCustomerDialog, setOpenConfirmCustomerDialog] = useState(false);
    const [all, setAll] = useLocalStorage('download_customer_assets_all', false)
    const [popup, setPopup] = useLocalStorage('download_customer_assets_popup', true)

    useImperativeHandle(ref, () => ({

      openConfirmationPopup(customerId, customerName) {
        setCustomerId(customerId);
        setCustomerName(customerName);
        if (popup) {
            handleClickCustomerConfirmationPopup();
        }
        else {
            openWindow(customerId);
        }
      }

    }));


    const handleClickCustomerConfirmationPopup = () => {
      closeMenu();
      setOpenConfirmCustomerDialog(true);
    };

    const handleCloseConfirmationCustomer = () => {
      setOpenConfirmCustomerDialog(false);
    };

    const handleConfirmCustomer = async() => {
        openWindow(customerId);
    };

    const downloadMerged = async(current) => {
        openWindowMerged(customerId, current);
    };

    const openWindow = (cid) => {
      window.open(
      `${config.clientApi}/export/assets.xls?invf=-1&cid=${cid}&all=${all}`,
      '_blank'
      );

      handleCloseConfirmationCustomer();
    }

    const openWindowMerged = (cid, current) => {
      window.open(
      `${config.clientApi}/export/assets.xls?invf=-1&cid=${cid}&merge=true&current=${current}`,
      '_blank'
      );

      handleCloseConfirmationCustomer();
    }

    function handleAllChecked(e) {
        setAll(e.target.checked);
        localStorage.setItem('download_customer_assets_all', e.target.checked);
    }

    function handlePopupChecked(e) {
        setPopup(e.target.checked);
        localStorage.setItem('download_customer_assets_popup', e.target.checked);
    }

  return (
    <>
    <Dialog open={openConfirmCustomerDialog} onClose={handleCloseConfirmationCustomer} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle id="form-dialog-title">Download Customer CSV File</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to download customer CSV file for customer <span className={classes.bold}>{customerName}</span> ({customerId})?
        </DialogContentText>
        <DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={all}
                onChange={handleAllChecked}
                name="download_all"
                color="primary"
              />
            }
            label="Include All Assets and Sites"
          />
          <span className={classes.helper}>Uncheck the box to include only ACTIVE sites and assets</span>
        </DialogContentText>
        <DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={popup}
                onChange={handlePopupChecked}
                name="popup"
                color="primary"
              />
            }
            label="Show me this popup again"
          />

          <span className={classes.helper}>You can change settings through User icon in the header</span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => downloadMerged(true)} className={classes.downloadMergedCSVButton}>
          Asset Tested CSV (Current Month, Merged)
        </Button>
        <Button onClick={() => downloadMerged(false)} className={classes.downloadMergedCSVButton}>
          Asset Tested CSV (Previous Month, Merged)
        </Button>
        <Button onClick={handleCloseConfirmationCustomer} className={classes.cancelButton}>
          Cancel
        </Button>
        <Button onClick={handleConfirmCustomer}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
});
export default CustomerDownloadCSVConfirmation;
